import "../../../constants/index.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function accountVariablesEndpoints(builder) {
  return {
    getAccountVariable: builder.query({
      providesTags: ["account-variables"],
      query: ({ query }) => ({
        url: `/member/account-variables${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  accountVariablesEndpoints as default
};
